import Heading from '../typography/Heading';
import Paragraph from '../typography/Paragraph';
import SectionHeader from './SectionHeader';

interface FeatureImage {
  src: string;
  alt: string;
  width?: number;
  height?: number;
  className?: string;
}

interface Feature {
  mainHeading: string;
  mainText: string;
  subHeading: string;
  subText: string;
  images: FeatureImage[];
  swapOrder: boolean;
  imageContainerClass?: string;
}

const features: Feature[] = [
  {
    mainHeading: 'Simplify resident & payment management',
    mainText:
      'A complete platform to manage residents, payments, announcements, and reports all in one place.',
    subHeading: 'Resident management',
    subText:
      'Easily add, update, and archive residents with full history tracking.',
    images: [
      {
        src: '/assets/images/home/resident-management.svg',
        alt: 'resident management feature',
        width: 600,
        height: 400,
      },
    ],
    swapOrder: false,
  },
  {
    mainHeading: 'One dashboard, total control',
    mainText:
      'Track residents, automate payments, send announcements, and access real-time financial insights effortlessly.',
    subHeading: 'Payment processing',
    subText:
      'Automated billing & Stripe integration for one-time or recurring payments.',
    imageContainerClass: 'w-full md:w-90 mx-auto',
    images: [
      {
        src: '/assets/images/home/payment-card.png',
        alt: 'resident management feature',
        width: 600,
        height: 400,
      },
    ],
    swapOrder: true,
  },
  {
    mainHeading: 'Smarter management for smoother operations',
    mainText:
      'From resident details to payment processing and financial reports everything you need is streamlined.',
    subHeading: 'Announcements & communication',
    subText: 'Instantly notify residents with important updates.',
    imageContainerClass: 'w-full relative mt-20',
    images: [
      {
        src: '/assets/images/home/notification.png',
        alt: 'resident management feature',
        className: 'absolute -top-8 right-[100px]',
      },
      {
        src: '/assets/images/home/announcement.png',
        alt: 'resident management feature',
        className: 'w-full',
      },
    ],
    swapOrder: false,
  },
  {
    mainHeading: 'Manage, track & grow with ease',
    mainText:
      'Simplify your operations with automated payments, instant announcements, and powerful reporting tools.',
    subHeading: 'Financial reports',
    subText:
      'Gain insights into payments, dues, and overall financial health.',
    images: [
      {
        src: '/assets/images/home/financial-reports.png',
        alt: 'resident management feature',
        width: 600,
        height: 400,
      },
    ],
    swapOrder: true,
  },
];

const KeyFeaturesBenefits = () => {
  return (
    <div className="w-full pt-4 md:pt-16">
      <div className="container mx-auto px-5 lg:px-0">
        <SectionHeader
          heading="Discover of the key features & benefits"
          subtitle=" Explore how our platform streamlines operations, saves time, and
            enhances control."
        />

        <div>
      <div>
        {features.map((feature, index) => (
          <div
            key={index}
            className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-8 mb-4 md:mb-8 text-center lg:text-start"
          >
            {/* Left Content (or Right Content based on order) */}
            <div
              className={`flex items-center ${
                feature.swapOrder ? 'lg:order-2' : ''
              }`}
            >
              <div className="hidden lg:block">
                <Heading>{feature.mainHeading}</Heading>
                <Paragraph>{feature.mainText}</Paragraph>
              </div>
            </div>

            {/* Right Content (or Left Content based on order) */}
            <div
              className={`p-0 md:p-8 ${feature.swapOrder ? 'lg:order-1' : ''}`}
            >
              <div className="mb-4 md:mb-10">
                <Heading as="h3" className="md:!text-[32px]">
                  {feature.subHeading}
                </Heading>
                <Paragraph>{feature.subText}</Paragraph>
              </div>
              <div className={feature.imageContainerClass || 'w-full'}>
                {feature.images.map((img, imgIndex) => (
                  <img
                    key={imgIndex}
                    className={img.className || 'w-full'}
                    src={img.src}
                    alt={img.alt}
                    width={img.width}
                    height={img.height}
                  />
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
        </div>
      </div>
    </div>
  );
};

export default KeyFeaturesBenefits;
